<template>
    <div
        :class="{
            'offline-pay-card': true,
        }"
    >
        <div class="offline-pay-card-content">
            <div class="offline-pay-desc">{{ data.skuDesc }}</div>
            <div v-if="data.type === 'coupon'" class="offline-pay-coupon-count">
                <span class="offline-pay-icon"></span>
                <span>{{ data.count }}</span>
            </div>
            <div v-else class="offline-pay-times-count">
                <span class="offline-pay-count">{{ data.count }}</span>
                <span>/次</span>
            </div>
        </div>
        <div class="offline-pay-footer">
            {{ data.skuName }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'OfflinePayCard',
    components: {
    },
    props: {
        data: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            // 组件的初始数据
        };
    },
    computed: {
    },
    methods: {
    }

};
</script>

<style scoped lang="less">
.offline-pay-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 120px;
    height: 148px;
    position: relative;
    background: #FEFDF7;
    border: 1.5px solid #FFEBC4;
    border-radius: 10px;
    user-select: none;

    &-content {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
        flex: 1;
        padding: 24px 0 16px 0;
    }
    .offline-pay-desc {
        font-family: PingFang SC;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
    }
    .offline-pay-coupon-count {
        height: 34px;
        font-family: "Baidu Number Plus", "Baidu Number";
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 20px;
        display: flex;
        align-items: center;
        gap: 4px;

        /* 功能色/黄/黄-active-W8 */
        color: #D88F00;
    }
    .offline-pay-times-count {
        height: 34px;
        font-family: 'PingFang SC';
        font-size: 12px;
        line-height: 16px;
        display: flex;
        align-items: baseline;
        gap: 2px;
        /* 深灰/深灰-G9 */
        color: #191B1E;

        .offline-pay-count {
            font-family: "Baidu Number Plus", "Baidu Number";
            font-size: 24px;
            font-weight: 500;
            line-height: 34px;
        }

    }
    .offline-pay-icon {
        display: inline-block;
        width: 20px;
        height: 20px;
        background: url(https://qiaojiang.bj.bcebos.com/fe/iconGoldenDiamond_72x72.png) no-repeat;
        background-size: 100%;
    }
    .offline-pay-footer {
        width: 100%;
        height: 38px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #D88F00;
        border-radius: 0 0 10px 10px;
        background: linear-gradient(
            267.45deg,
            rgba(255, 227, 174, 0.5) 0%,
            rgba(255, 244, 222, 0.5) 48.25%,
            rgba(253, 239, 197, 0.5) 96.13%
        );
        //styleName: T2 小标题/medium;
        font-family: PingFang SC;
        font-size: 16px;
        font-weight: 500;
    }


}
</style>